module.exports = __webpack_public_path__ + "static/img/sec-cont-bg.423a036.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/sec-cont-bg.png
// module id = aM3D
// module chunks = 1